import { render } from "./PaySuccess.vue?vue&type=template&id=3259767d&scoped=true"
import script from "./PaySuccess.vue?vue&type=script&lang=js"
export * from "./PaySuccess.vue?vue&type=script&lang=js"

import "./PaySuccess.vue?vue&type=style&index=0&id=3259767d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3259767d"

export default script